// extracted by mini-css-extract-plugin
module.exports = {"submitted":"Submitted_submitted__1kS-d","titles":"Submitted_titles__2oD0Y","content":"Submitted_content__vMFXR"};